/**
 * Wyszukiwanie predykcyjne Shopify (suggest.json) + podświetlenie + propozycje przy braku wyników.
 * Ortografia: silnik Shopify + lokalne warianty zapytań (typowe pomyłki PL).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 160;
  var MIN_CHARS = 1;
  var SUGGEST_LIMIT = 10;
  var root = '';

  function getRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != null) {
      var r = String(window.Shopify.routes.root);
      if (r === '/' || r === '') return '';
      return r.replace(/\/$/, '');
    }
    return '';
  }

  function escapeHtml(s) {
    if (s == null || s === '') return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /** Podświetla słowa z frazy w tekście (bezpiecznie po escape HTML). */
  window.psiabudaHighlightSearch = function (text, query) {
    var esc = escapeHtml(text);
    var q = (query || '').trim();
    if (!q) return esc;
    var words = q.split(/\s+/).filter(function (w) {
      return w.length >= 1;
    });
    if (!words.length) return esc;
    var out = esc;
    words.forEach(function (w) {
      try {
        var re = new RegExp('(' + escapeRegExp(w) + ')', 'gi');
        out = out.replace(re, '<mark class="search-highlight">$1</mark>');
      } catch (e) { /* ignore */ }
    });
    return out;
  };

  /** Warianty zapytań przy zerowych wynikach (proste heurystyki PL + literówki). */
  function queryVariants(q) {
    var t = (q || '').trim();
    if (t.length < 2) return [];
    var seen = {};
    var out = [];
    function add(s) {
      if (!s || s === t || s.length < 2) return;
      if (seen[s]) return;
      seen[s] = true;
      out.push(s);
    }

    if (t.length >= 4) add(t.slice(0, -1));

    var i;
    for (i = 0; i < t.length - 1; i++) {
      var arr = t.split('');
      var tmp = arr[i];
      arr[i] = arr[i + 1];
      arr[i + 1] = tmp;
      add(arr.join(''));
    }

    var map = [
      ['ż', 'z'],
      ['ź', 'z'],
      ['ó', 'o'],
      ['ą', 'a'],
      ['ę', 'e'],
      ['ć', 'c'],
      ['ń', 'n'],
      ['ł', 'l'],
      ['ś', 's']
    ];
    map.forEach(function (pair) {
      if (t.indexOf(pair[0]) !== -1) add(t.split(pair[0]).join(pair[1]));
      if (t.indexOf(pair[1]) !== -1 && pair[1].length === 1) add(t.split(pair[1]).join(pair[0]));
    });

    return out.slice(0, 5);
  }

  function fetchSuggest(query) {
    root = getRoot();
    var base = root ? root + '/' : '/';
    var url =
      base +
      'search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' +
      SUGGEST_LIMIT +
      '&resources[options][unavailable_products]=last';
    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('suggest');
      return r.json();
    });
  }

  /**
   * Przy pustym polu: pierwsze produkty z kolekcji „all” (JSON), potem zapasowo suggest z „a”.
   */
  function fetchBootstrapProducts() {
    root = getRoot();
    var base = root ? root + '/' : '/';
    return fetch(base + 'collections/all/products.json?limit=8', {
      method: 'GET',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('bootstrap');
        return r.json();
      })
      .then(function (json) {
        var raw = json.products || [];
        var products = raw.map(function (p) {
          var v = p.variants && p.variants[0];
          var priceStr = '';
          if (v && v.price != null) priceStr = String(v.price);
          var img = '';
          if (p.images && p.images[0] && p.images[0].src) img = p.images[0].src;
          return {
            title: p.title,
            url: '/products/' + p.handle,
            featured_image: img,
            price: priceStr
          };
        });
        if (!products.length) throw new Error('empty');
        return { resources: { results: { products: products, queries: [] } } };
      })
      .catch(function () {
        return fetchSuggest('a');
      });
  }

  function parseSuggest(json) {
    var products = [];
    var queries = [];
    try {
      var res = json.resources && json.resources.results;
      if (res) {
        if (res.products) products = res.products;
        if (res.queries) queries = res.queries;
      }
      if (!products.length && json.results && json.results.products) {
        products = json.results.products;
      }
    } catch (e) { /* ignore */ }
    return { products: products, queries: queries };
  }

  function productImageUrl(p) {
    if (!p) return '';
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (p.image) return typeof p.image === 'string' ? p.image : p.image.url;
    if (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.url) {
      return p.media[0].preview_image.url;
    }
    return '';
  }

  function productPrice(p) {
    if (!p) return '';
    var raw = null;
    if (p.price != null) raw = p.price;
    else if (p.price_min != null) raw = p.price_min;
    if (raw == null || raw === '') return '';
    var s = String(raw);
    /* Już sformatowane (z walutą) — zostaw jak jest */
    if (/zł|PLN/i.test(s)) return s;
    var n = parseFloat(s.replace(/\s/g, '').replace(',', '.'));
    if (isNaN(n)) return s;
    return n.toFixed(2).replace('.', ',') + ' zł';
  }

  function stripHtml(s) {
    return String(s || '').replace(/<[^>]*>/g, '');
  }

  function hrefForShopUrl(url) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) return url;
    return getRoot() + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function initSinglePredictive(wrap) {
    root = getRoot();

    var form = wrap.querySelector('[data-predictive-search-form]');
    var input = wrap.querySelector('[data-predictive-search-input]');
    var dropdown = wrap.querySelector('[data-predictive-dropdown]');
    if (!form || !input || !dropdown) return;

    var timer = null;
    var activeIndex = -1;

    function closeDropdown() {
      dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function openDropdown() {
      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function renderLoading() {
      dropdown.innerHTML =
        '<div class="predictive-search__inner"><p class="predictive-search__status">Szukam…</p></div>';
      openDropdown();
    }

    function renderError() {
      dropdown.innerHTML =
        '<div class="predictive-search__inner"><p class="predictive-search__status predictive-search__status--error">Nie udało się pobrać podpowiedzi. Spróbuj wyszukać po naciśnięciu Enter.</p></div>';
      openDropdown();
    }

    function renderResultsHtml(data, query, flags) {
      flags = flags || {};
      var isBootstrap = flags.bootstrap === true;
      var parsed = parseSuggest(data);
      var products = parsed.products || [];
      var queries = parsed.queries || [];

      var innerAttrs = isBootstrap ? ' data-predictive-bootstrap="true"' : '';
      var html = '<div class="predictive-search__inner"' + innerAttrs + '>';
      if (queries.length) {
        html += '<div class="predictive-search__queries"><span class="predictive-search__section-label">Propozycje</span>';
        queries.slice(0, 4).forEach(function (qq) {
          var text = stripHtml(qq.text || qq.styled_text || '');
          if (!text) return;
          var rawUrl = qq.url || '/search?q=' + encodeURIComponent(text);
          var href = hrefForShopUrl(rawUrl);
          html +=
            '<a class="predictive-search__query-link" href="' +
            escapeHtml(href) +
            '">' +
            window.psiabudaHighlightSearch(text, query) +
            '</a>';
        });
        html += '</div>';
      }

      if (!products.length) {
        html +=
          '<p class="predictive-search__status">' +
          (isBootstrap
            ? 'Brak produktów do wyświetlenia.'
            : 'Brak produktów dla tej frazy — naciśnij Enter, aby przeszukać sklep.') +
          '</p></div>';
        dropdown.innerHTML = html;
        openDropdown();
        return;
      }

      html +=
        '<span class="predictive-search__section-label">' +
        (isBootstrap ? 'Polecane z katalogu' : 'Produkty') +
        '</span><ul class="predictive-search__list" role="listbox">';
      products.forEach(function (p, idx) {
        var title = p.title || '';
        var url = p.url || '#';
        if (!/^https?:\/\//i.test(url)) url = root + (url.charAt(0) === '/' ? url : '/' + url);
        var img = productImageUrl(p);
        var price = productPrice(p);
        html += '<li class="predictive-search__item" role="none">';
        html +=
          '<a role="option" class="predictive-search__link" href="' +
          escapeHtml(url) +
          '" data-idx="' +
          idx +
          '">';
        html += '<span class="predictive-search__thumb">';
        if (img) html += '<img src="' + escapeHtml(img) + '" alt="" width="52" height="52" loading="lazy">';
        html += '</span><span class="predictive-search__meta">';
        html += '<span class="predictive-search__title">' + window.psiabudaHighlightSearch(title, query) + '</span>';
        if (price) html += '<span class="predictive-search__price">' + escapeHtml(price) + '</span>';
        html += '</span></a></li>';
      });
      html += '</ul>';
      if (isBootstrap) {
        html +=
          '<div class="predictive-search__footer"><a class="predictive-search__view-all" href="' +
          escapeHtml(root + '/collections/all') +
          '">Cały katalog →</a></div>';
      } else {
        html +=
          '<div class="predictive-search__footer"><a class="predictive-search__view-all" href="' +
          escapeHtml(root + '/search?q=' + encodeURIComponent(query)) +
          '">Zobacz wszystkie wyniki →</a></div>';
      }
      html += '</div>';
      dropdown.innerHTML = html;
      openDropdown();

      dropdown.querySelectorAll('.predictive-search__link').forEach(function (a) {
        a.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
      });
    }

    function runFetch(q) {
      if (q.length === 0) {
        if (!dropdown.hidden && dropdown.querySelector('[data-predictive-bootstrap]')) {
          openDropdown();
          return;
        }
        renderLoading();
        fetchBootstrapProducts()
          .then(function (data) {
            renderResultsHtml(data, '', { bootstrap: true });
          })
          .catch(function () {
            renderError();
          });
        return;
      }
      if (q.length < MIN_CHARS) {
        closeDropdown();
        return;
      }
      renderLoading();
      fetchSuggest(q)
        .then(function (data) {
          var parsed = parseSuggest(data);
          if (parsed.products && parsed.products.length) {
            return data;
          }
          if (q.length >= 3) {
            var alt = queryVariants(q)[0];
            if (alt) return fetchSuggest(alt);
          }
          return data;
        })
        .then(function (data) {
          renderResultsHtml(data, q, { bootstrap: false });
        })
        .catch(function () {
          renderError();
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length === 0) {
        timer = setTimeout(function () {
          runFetch('');
        }, DEBOUNCE_MS);
        return;
      }
      timer = setTimeout(function () {
        runFetch(q);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length === 0) {
        runFetch('');
      } else {
        if (dropdown.hidden || !dropdown.querySelector('.predictive-search__list')) {
          runFetch(q);
        } else {
          openDropdown();
        }
      }
    });

    input.addEventListener('keydown', function (e) {
      var links = dropdown.querySelectorAll('.predictive-search__link');
      if (!links.length || dropdown.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = activeIndex < 0 ? 0 : Math.min(activeIndex + 1, links.length - 1);
        links.forEach(function (a, i) {
          a.classList.toggle('is-active', i === activeIndex);
        });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = activeIndex <= 0 ? -1 : activeIndex - 1;
        links.forEach(function (a, i) {
          a.classList.toggle('is-active', i === activeIndex);
        });
      } else if (e.key === 'Enter' && activeIndex >= 0 && links[activeIndex]) {
        e.preventDefault();
        window.location.href = links[activeIndex].href;
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeDropdown();
    });

    form.addEventListener('submit', function () {
      closeDropdown();
    });
  }

  function initHeaderPredictive() {
    var wraps = document.querySelectorAll('[data-predictive-search-wrap]');
    wraps.forEach(function (wrap) {
      initSinglePredictive(wrap);
    });
  }

  function highlightSearchPage() {
    var grid = document.querySelector('[data-search-results-grid]');
    var terms = document.querySelector('[data-search-terms]');
    if (!terms) return;
    var q = terms.getAttribute('data-search-terms') || '';
    if (!q.trim()) return;

    if (grid) {
      grid.querySelectorAll('.product-card .product-card__title').forEach(function (h3) {
        var raw = h3.textContent;
        h3.innerHTML = window.psiabudaHighlightSearch(raw, q);
      });
    }

    document.querySelectorAll('.search-page__result-title a').forEach(function (a) {
      var raw = a.textContent;
      a.innerHTML = window.psiabudaHighlightSearch(raw, q);
    });

    var countEl = document.querySelector('[data-search-count-highlight]');
    if (countEl) {
      var strongs = countEl.querySelectorAll('strong');
      if (strongs.length >= 2) {
        var phrase = strongs[1].textContent;
        strongs[1].innerHTML = window.psiabudaHighlightSearch(phrase, q);
      }
    }
  }

  function loadEmptyStateAlternatives() {
    var empty = document.querySelector('[data-search-empty]');
    if (!empty) return;

    root = getRoot();

    var termsEl = document.querySelector('[data-search-terms]');
    var q = termsEl ? termsEl.getAttribute('data-search-terms') || '' : '';
    q = q.trim();
    if (q.length < 2) return;

    var altBox = document.querySelector('[data-search-alternatives]');
    var productsBox = document.querySelector('[data-search-suggested-products]');

    var variants = queryVariants(q);
    if (altBox && variants.length) {
      altBox.hidden = false;
      altBox.innerHTML =
        '<p class="search-page__alternatives-title">Spróbuj podobnych zapytań:</p><ul class="search-page__alternatives-list">' +
        variants
          .map(function (v) {
            return (
              '<li><a href="' +
              escapeHtml(root + '/search?q=' + encodeURIComponent(v)) +
              '">' +
              escapeHtml(v) +
              '</a></li>'
            );
          })
          .join('') +
        '</ul>';
    }

    fetchSuggest(q)
      .then(function (data) {
        var parsed = parseSuggest(data);
        var products = parsed.products || [];
        if (products.length && productsBox) {
          productsBox.hidden = false;
          var html =
            '<h2 class="search-page__suggested-title">Propozycje z katalogu</h2><div class="search-page__results-grid">';
          products.slice(0, 4).forEach(function (p) {
            var url = p.url || '#';
            if (url.indexOf('http') !== 0) url = root + url;
            var img = productImageUrl(p);
            var title = p.title || '';
            var price = productPrice(p);
            html += '<div class="search-page__result-item search-page__result-item--mini">';
            html += '<a href="' + escapeHtml(url) + '" class="search-page__mini-link">';
            if (img) html += '<img src="' + escapeHtml(img) + '" alt="" width="80" height="80" loading="lazy" style="border-radius:8px;object-fit:cover;">';
            html += '<div><strong>' + window.psiabudaHighlightSearch(title, q) + '</strong>';
            if (price) html += '<div style="color:var(--color-primary);font-weight:700;margin-top:6px;">' + escapeHtml(price) + '</div>';
            html += '</div></a></div>';
          });
          html += '</div>';
          productsBox.innerHTML = html;
        }
      })
      .catch(function () { /* ignore */ });
  }

  function initSearchPage() {
    if (!document.body.classList.contains('template-search')) return;
    root = getRoot();
    highlightSearchPage();
    if (document.querySelector('[data-search-empty]')) {
      loadEmptyStateAlternatives();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeaderPredictive();
      initSearchPage();
    });
  } else {
    initHeaderPredictive();
    initSearchPage();
  }
})();
